<template>
  <div class="bg-white py-16">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
      
        <div class="mt-6">
          <a 
            href="https://www.youtube.com/@royaleharmonieemulationsta2962/videos" 
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-colors duration-200"
          >
            <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
            Voir notre chaîne YouTube
          </a>
        </div>
      </div>
      
      <!-- Loading state -->
      <div v-if="loading" class="flex justify-center">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
      
      <!-- Error state -->
      <div v-else-if="error" class="text-center text-gray-500">
        <p>Impossible de charger les vidéos. Veuillez réessayer plus tard.</p>
        <button @click="loadVideos" class="btn-primary mt-4">Réessayer</button>
      </div>
      
      <!-- Videos grid -->
      <div v-else-if="videos.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div 
          v-for="video in videos" 
          :key="video.id"
          class="card hover:shadow-lg transition-shadow duration-300"
        >
          <!-- Video player -->
          <div class="relative mb-4">
            <div class="aspect-video rounded-lg overflow-hidden">
              <iframe 
                v-if="video.video_type === 'youtube'"
                :src="getYouTubeEmbedUrl(video.video_url)"
                class="w-full h-full"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
              <div 
                v-else
                v-html="video.video_url"
                class="w-full h-full"
              ></div>
            </div>
          </div>
          
          <!-- Video info -->
          <h3 class="text-xl font-bold text-gray-900 mb-2">{{ video.title }}</h3>
          <p v-if="video.description" class="text-gray-600 text-sm line-clamp-3">
            {{ video.description }}
          </p>
          
          <!-- Video actions -->
          <div class="mt-4 flex space-x-2">
            <a 
              v-if="video.video_type === 'youtube'"
              :href="video.video_url"
              target="_blank"
              rel="noopener noreferrer"
              class="inline-flex items-center px-3 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-md transition-colors duration-200"
            >
              <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
              Voir sur YouTube
            </a>
            <button 
              @click="openVideo(video)"
              class="inline-flex items-center px-3 py-2 bg-gray-600 hover:bg-gray-700 text-white text-sm font-medium rounded-md transition-colors duration-200"
            >
              <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
              </svg>
              Plein écran
            </button>
          </div>
        </div>
      </div>
      
      <!-- Empty state -->
      <div v-else class="text-center text-gray-500">
        <p>Aucune vidéo disponible pour le moment.</p>
      </div>
    </div>
    
    <!-- Video modal -->
    <div 
      v-if="selectedVideo" 
      class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
      @click="closeVideo"
    >
      <div class="max-w-4xl max-h-full bg-white rounded-lg overflow-hidden" @click.stop>
        <div class="relative">
          <!-- Video player -->
          <div class="aspect-video">
            <iframe 
              v-if="selectedVideo.video_type === 'youtube'"
              :src="getYouTubeEmbedUrl(selectedVideo.video_url)"
              class="w-full h-full"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <div 
              v-else
              v-html="selectedVideo.video_url"
              class="w-full h-full"
            ></div>
          </div>
          
          <!-- Close button -->
          <button 
            @click="closeVideo"
            class="absolute top-4 right-4 bg-black bg-opacity-50 text-white rounded-full p-2 hover:bg-opacity-75 transition-colors"
          >
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        
        <!-- Video details -->
        <div class="p-6">
          <h3 class="text-2xl font-bold text-gray-900 mb-2">{{ selectedVideo.title }}</h3>
          <p v-if="selectedVideo.description" class="text-gray-600">
            {{ selectedVideo.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { videoService } from '../services/videoService'

export default {
  name: 'VideoSection',
  data() {
    return {
      videos: [],
      loading: true,
      error: false,
      selectedVideo: null
    }
  },
  async mounted() {
    await this.loadVideos()
  },
  methods: {
    async loadVideos() {
      try {
        this.loading = true
        this.error = false
        this.videos = await videoService.getVideos()
      } catch (error) {
        console.error('Error loading videos:', error)
        this.error = true
      } finally {
        this.loading = false
      }
    },
    openVideo(video) {
      this.selectedVideo = video
    },
    closeVideo() {
      this.selectedVideo = null
    },
    getYouTubeEmbedUrl(url) {
      // Convert YouTube watch URL to embed URL
      const videoId = this.extractYouTubeId(url)
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`
      }
      return url
    },
    extractYouTubeId(url) {
      // Extract YouTube video ID from various URL formats
      const patterns = [
        /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
        /youtube\.com\/v\/([^&\n?#]+)/,
        /youtube\.com\/user\/[^\/]+\/.*#(?:.*\/)?([^&\n?#]+)/
      ]
      
      for (const pattern of patterns) {
        const match = url.match(pattern)
        if (match) {
          return match[1]
        }
      }
      return null
    }
  }
}
</script>

<style scoped>
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.aspect-video {
  aspect-ratio: 16 / 9;
}

/* Fallback for older browsers */
@supports not (aspect-ratio: 16 / 9) {
  .aspect-video {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 aspect ratio */
    height: 0;
  }
  
  .aspect-video iframe,
  .aspect-video > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
